// The curated live controls guest play offers. The server's
// `invite::time_control` is the only parser; this list only draws the picker.
import { t } from "../i18n/index.ts";

export type Control = "10+0" | "5+0" | "5+3" | "3+2" | "untimed";
export const CONTROLS: Control[] = ["10+0", "5+0", "5+3", "3+2", "untimed"];
export const DEFAULT_CONTROL: Control = "5+3";

/** The same choices drive the computer's browser-local Fischer clock. */
export function localClock(control: Control): { tc: Control; baseMs: number; incMs: number } {
  const [minutes, increment] = control === "untimed" ? [0, 0] : control.split("+").map(Number);
  return { tc: control, baseMs: minutes * 60_000, incMs: increment * 1000 };
}

export interface Terms { clock_mode?: string; tc?: string; speed?: string; rated?: boolean }

/** Setup or seek terms for one control. Untimed stays the bare legacy shape. */
export function controlTerms(control: Control): { clock_mode: "timed" | "untimed"; tc?: string } {
  return control === "untimed" ? { clock_mode: "untimed" } : { clock_mode: "timed", tc: control };
}

/** "5+3" or "No clock": the short form a sentence or a queue row carries. */
export function clockLabel(terms: Terms | undefined): string {
  return terms?.clock_mode === "timed" && terms.tc ? terms.tc : t("clock.untimed");
}

/** "5+3 · Blitz · unrated" or "No clock · unrated". Guest play is never rated. */
export function termsLabel(terms: Terms | undefined): string {
  if (terms?.clock_mode !== "timed" || !terms.tc) return t("clock.termsUntimed");
  const speed = terms.speed === "rapid" ? t("chess.rapid") : t("chess.blitz");
  return t("clock.terms", { clock: terms.tc, speed });
}

/** Five choices, 5+3 selected, as one radio group. */
export function clockPicker(name = "tc"): string {
  return `<fieldset class="clock-picker"><legend>${t("clock.legend")}</legend><div class="clock-options">${CONTROLS.map(c =>
    `<label><input type="radio" name="${name}" value="${c}"${c === DEFAULT_CONTROL ? " checked" : ""} /><span>${c === "untimed" ? t("clock.untimed") : c}</span></label>`).join("")}</div></fieldset>`;
}

export function pickedControl(root: ParentNode, name = "tc"): Control {
  const value = root.querySelector<HTMLInputElement>(`input[name="${name}"]:checked`)?.value;
  return CONTROLS.includes(value as Control) ? value as Control : DEFAULT_CONTROL;
}
